import { useMemo } from "react";
import {
  useGetAdmissionsApplicationQuery,
  useGetAdmissionsDocumentsQuery,
  useGetAdmissionsTimelineQuery,
} from "../../../state/domainRouterApi";
import { useDomainRouterQuery } from "../../../state/domainRouterHooks";
import { toAdmissionsDashboardApplicant } from "../../../shared/admissions-dashboard-artifacts";

export function useAdmissionsDashboardApplicants(limit = 200) {
  const query = useDomainRouterQuery("listApplications", {
    limit,
    projection: "dashboard",
    sourceScope: "complete",
  });
  const applicants = useMemo(
    () =>
      (query.data?.items ?? []).map((item) =>
        toAdmissionsDashboardApplicant(item as Record<string, unknown>),
      ),
    [query.data?.items],
  );
  return { query, applicants };
}

export function useAdmissionsApplication(applicationId: string) {
  const query = useGetAdmissionsApplicationQuery(applicationId, {
    skip: !applicationId,
  });
  return query;
}

export function useAdmissionsDocuments(applicationId: string) {
  return useGetAdmissionsDocumentsQuery(
    { applicationId, limit: 200 },
    { skip: !applicationId },
  );
}

export function useAdmissionsTimeline(applicationId: string) {
  return useGetAdmissionsTimelineQuery(
    { applicationId, limit: 200 },
    { skip: !applicationId },
  );
}
